import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "./ui/accordion";

const FAQS = [
  {
    q: "What time is the Sunday Ground Teer result declared?",
    a: "The First Round (F/R) Sunday Ground Teer result is declared around 4:30 PM and the Second Round (S/R) around 5:30 PM every day. Results are updated here instantly.",
  },
  {
    q: "What is a Common Number in Sunday Ground Teer?",
    a: "A Common Number is the most probable Direct, House and Ending number for today's teer, calculated from previous results. It is a reference only and does not guarantee any outcome.",
  },
  {
    q: "What is a Dream Number?",
    a: "A Dream Number links what you see in your dream (like snake, water, money) to a traditional lucky number. Use our Dream Number chart to find yours.",
  },
  {
    q: "Where can I see previous Sunday Ground Teer results?",
    a: "Our Previous Result page has the complete archive from 2019 to 2026 with F/R and S/R numbers, filterable by year.",
  },
  {
    q: "How do I check the result of a specific date?",
    a: "Open the Teer Club Chart page, pick any date from the calendar and the F/R and S/R result of that day appears instantly.",
  },
];

export default function FaqSection() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="max-w-5xl mx-auto px-4 mt-8">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-7">
        <h2 className="text-xl sm:text-2xl font-black text-[#1f2733] mb-4">
          Frequently Asked Questions
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left font-bold text-[#1f2733]">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </section>
  );
}
